import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { I as IframePlayer, R as ReactPlayerWrapper } from './IframePlayer.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { validate, mergeStyles, isSSR } from 'wix-rich-content-common';
import pluginVideoSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import { isEqual } from 'lodash';
import { s as styles } from './viewer-loadable2.js';
import 'react-player';
import 'ricos-schema';
import '@loadable/component';
import 'ricos-types';

var getVideoSrc = function getVideoSrc(src, settings) {
  if (settings === void 0) {
    settings = {};
  }
  if (typeof src === "object") {
    if (settings && settings.getVideoUrl) {
      return settings.getVideoUrl(src);
    } else {
      console.error("must set getVideoUrl in plugin config when using custom video source!", src);
    }
  }
  return src;
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var VideoViewer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(VideoViewer, _Component);
  function VideoViewer(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    __publicField(_assertThisInitialized(_this), "setUrl", function (newUrl) {
      var _a, _b;
      var url = _this.normalizeUrl(newUrl);
      if (url !== _this.state.url) {
        _this.setState({
          url: url
        });
        (_b = (_a = _this.props).onReload) == null ? void 0 : _b.call(_a);
      }
    });
    __publicField(_assertThisInitialized(_this), "normalizeUrl", function (url) {
      return url.toLowerCase().indexOf("vimeo") === 0 ? "https://" + url : url;
    });
    //vimeo player needs urls prefixed with http[s]
    __publicField(_assertThisInitialized(_this), "findFormalVideoRatio", function (ratio) {
      var baseRatios = [1, 5 / 4, 4 / 3, 3 / 2, 16 / 10, 16 / 9, 1.85, 2, 2.35, 2.39, 3];
      var videoRatios = [].concat(baseRatios, baseRatios.map(function (x) {
        return 1 / x;
      }));
      var findClosest = function findClosest(arr, target) {
        return arr.reduce(function (prev, curr) {
          return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev;
        });
      };
      var closest = findClosest(videoRatios, ratio);
      return Math.abs(closest - ratio) > 0.01 ? ratio : closest;
    });
    __publicField(_assertThisInitialized(_this), "onReactPlayerReady", function (player) {
      var _a, _b;
      if (!_this.props.isLoaded) {
        ((_b = (_a = _this.props).onReady) == null ? void 0 : _b.call(_a, player)) || _this.setState({
          isLoaded: true
        });
      }
    });
    __publicField(_assertThisInitialized(_this), "handleContextMenu", function (e) {
      return _this.props.componentData.disableDownload && e.preventDefault();
    });
    __publicField(_assertThisInitialized(_this), "disableDownloadProps", function () {
      var _this$props = _this.props,
        componentData = _this$props.componentData,
        settings = _this$props.settings;
      var disableProps = {
        config: {
          file: {
            attributes: {
              controlsList: "nodownload"
            }
          }
        }
      };
      var disable = {};
      if (componentData.disableDownload !== void 0) {
        disable = componentData.disableDownload ? disableProps : {};
      } else if (settings.disableDownload !== void 0) {
        disable = settings.disableDownload ? disableProps : {};
      }
      return disable;
    });
    __publicField(_assertThisInitialized(_this), "onProgress", function (progress) {
      var _a;
      var _this$props2 = _this.props,
        settings = _this$props2.settings,
        blockKey = _this$props2.blockKey;
      (_a = settings.onProgress) == null ? void 0 : _a.call(settings, __spreadProps(__spreadValues({}, progress), {
        id: blockKey
      }));
    });
    validate(props.componentData, pluginVideoSchema);
    _this.state = {
      url: void 0,
      isLoaded: false,
      isVideoWrapperAttachedToDom: false
    };
    var url = getVideoSrc(props.componentData.src, props.settings);
    if (typeof url === "string") {
      _this.state = {
        url: _this.normalizeUrl(url)
      };
    } else if (url && typeof url.then === "function") {
      url.then(function (url2) {
        return _this.setState({
          url: _this.normalizeUrl(url2)
        });
      });
    }
    return _this;
  }
  var _proto = VideoViewer.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginVideoSchema);
      if (!isEqual(nextProps.componentData.src, this.props.componentData.src)) {
        var url = getVideoSrc(nextProps.componentData.src, nextProps.settings);
        if (typeof url === "string") {
          this.setUrl(url);
        } else if (url && typeof url.then === "function") {
          url.then(function (url2) {
            return _this2.setUrl(url2);
          });
        }
      }
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      key: "mounted"
    });
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    var isVideoWrapperAttachedToDom = this.state.isVideoWrapperAttachedToDom;
    if (!isVideoWrapperAttachedToDom) {
      var videoRatio = this.getVideoRatio();
      if (videoRatio) {
        this.setVideoRatio(videoRatio.ratio, videoRatio.wrapper);
        this.setState({
          isVideoWrapperAttachedToDom: true
        });
      }
    }
  };
  _proto.getVideoRatio = function getVideoRatio() {
    var _a;
    var wrapper = (_a = ReactDOM.findDOMNode(this)) == null ? void 0 : _a.parentNode;
    if (!wrapper) {
      return void 0;
    }
    var element = wrapper.querySelector("iframe, video");
    if (!element) {
      return void 0;
    }
    var ratio = element.clientHeight / element.clientWidth;
    return !isNaN(ratio) ? {
      ratio: ratio,
      wrapper: wrapper
    } : void 0;
  };
  _proto.setVideoRatio = function setVideoRatio(ratio, wrapper) {
    wrapper.style["padding-bottom"] = ratio * 100 + "%";
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      theme = _this$props3.theme,
      width = _this$props3.width,
      height = _this$props3.height,
      disabled = _this$props3.disabled,
      setComponentUrl = _this$props3.setComponentUrl,
      onDuration = _this$props3.onDuration,
      settings = _this$props3.settings,
      muted = _this$props3.muted,
      componentData = _this$props3.componentData,
      seoMode = _this$props3.seoMode;
    this.styles = this.styles || mergeStyles({
      styles: styles,
      theme: theme
    });
    var _this$state = this.state,
      url = _this$state.url,
      key = _this$state.key;
    setComponentUrl == null ? void 0 : setComponentUrl(url);
    var isLoaded = this.props.isLoaded || this.state.isLoaded;
    var isCustomVideo = typeof componentData.src === "object";
    var shouldRenderIframe = isSSR() && seoMode;
    var _ref = componentData.options || {},
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$playInLoop = _ref.playInLoop,
      playInLoop = _ref$playInLoop === void 0 ? false : _ref$playInLoop,
      _ref$showControls = _ref.showControls,
      showControls = _ref$showControls === void 0 ? true : _ref$showControls;
    var props = __spreadValues({
      url: url,
      onReady: this.onReactPlayerReady,
      disabled: disabled,
      width: width,
      height: height,
      key: key,
      onDuration: onDuration,
      onProgress: this.onProgress,
      progressInterval: settings.progressInterval || 1e3,
      muted: muted || autoPlay,
      isLoaded: isLoaded,
      autoPlay: autoPlay,
      loop: playInLoop,
      isCustomVideo: isCustomVideo
    }, this.disableDownloadProps());
    return shouldRenderIframe ? /* @__PURE__ */React.createElement(IframePlayer, {
      isCustomVideo: isCustomVideo,
      url: url
    }) : /* @__PURE__ */React.createElement(ReactPlayerWrapper, __spreadValues({
      className: classNames(this.styles.video_player),
      onContextMenu: this.handleContextMenu,
      controls: this.props.isLoaded !== false && showControls
    }, props));
  };
  return VideoViewer;
}(Component);
VideoViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  onStart: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  settings: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  setComponentUrl: PropTypes.func,
  onReady: PropTypes.func,
  isLoaded: PropTypes.bool,
  onReload: PropTypes.func,
  onDuration: PropTypes.func,
  blockKey: PropTypes.string,
  muted: PropTypes.bool,
  seoMode: PropTypes.bool
};
VideoViewer.defaultProps = {
  width: "100%",
  height: "100%"
};

export { VideoViewer as default };

import 'wix-rich-content-plugin-video/dist/loadable/viewer/es/styles.viewer.min.global.css'